export default __webpack_public_path__ + "static/media/Verrufene-Stelle.efab9a3a.mp3";